import AdminPackage from 'components/Admin/Package/AdminPackage';

const AdminPackagePageList = () => {
	return <AdminPackage />;
};

export default AdminPackagePageList;
